export function fmtUsd(n) {
  if (n === null || n === undefined || isNaN(n)) return "$0";
  return "$" + fmtNum(n);
}

export function fmtNum(n, dec = 2) {
  if (n === null || n === undefined || isNaN(n)) return "0";
  const abs = Math.abs(n);
  if (abs >= 1e9) return (n / 1e9).toFixed(dec) + "B";
  if (abs >= 1e6) return (n / 1e6).toFixed(dec) + "M";
  if (abs >= 1e3) return (n / 1e3).toFixed(dec) + "K";
  return n.toFixed(dec);
}

export function fmtSui(n, dec = 2) {
  if (n === null || n === undefined || isNaN(n)) return "0";
  return Number(n).toLocaleString(undefined, { maximumFractionDigits: dec });
}

export function fmtPrice(n) {
  if (!n || isNaN(n)) return "0";
  const abs = Math.abs(n);
  if (abs >= 1) return Number(n).toLocaleString(undefined, { maximumFractionDigits: 4 });
  let dec = 6;
  if (abs < 0.0001) dec = 9;
  if (abs < 1e-7) dec = 12;
  return n.toFixed(dec).replace(/(\.\d*?)0+$/, "$1").replace(/\.$/, "");
}

export function timeAgo(iso) {
  const d = new Date(iso);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
}

const VIRTUAL_SUI = 1000; // SUI virtual reserve baked into the deployed Config

// Turn on-chain get_state (BigInts) + coin metadata into the display shape used by cards.
export function onchainMetrics(coin, state) {
  const dec = coin.decimals ?? 9;
  const scale = 10 ** dec;
  const realMist = Number(state.real_sui_collected);
  const gradMist = Number(state.graduation_sui) || 7_500_000_000_000;
  const tokenSupply = Number(state.token_supply) / scale || 1;
  // Price includes the virtual reserve so the market cap starts high (e.g. ~$3.5k) and
  // stays continuous through migration. grad_price = (virtual+real)/reserve is also the
  // Cetus pool seed price, so the displayed price does not drop after migration.
  const suiEff = VIRTUAL_SUI + realMist / 1e9;
  let tokenReserve = Number(state.token_reserve) / scale;
  if (state.migrated && tokenReserve <= 0 && suiEff > 0) {
    tokenReserve = (VIRTUAL_SUI * tokenSupply) / suiEff;
  }
  const price = tokenReserve > 0 ? suiEff / tokenReserve : 0;
  return {
    ...coin,
    price_sui: price,
    market_cap_sui: price * tokenSupply,
    real_sui_collected: realMist / 1e9,
    sui_remaining: Math.max(gradMist - realMist, 0) / 1e9,
    progress: gradMist ? Math.min(realMist / gradMist, 1) : 0,
    migrated: state.migrated,
    dev_bought_first: state.dev_bought_first,
    first_trade_done: Number(state.volume_sui) > 0,
    volume_sui: Number(state.volume_sui) / 1e9,
    token_reserve_whole: tokenReserve,
    token_supply_whole: tokenSupply,
  };
}

